module.exports = __webpack_public_path__ + "img/jack-parkin.225575c4.jpg";